module.exports = __webpack_public_path__ + "265a87996f68b2bdf25c2e41ab0b1ee7.jpg";